import { useCallback } from 'react';
import { ActionEnum, useDispatch, useMappedState } from '../store/store';
export var useOptions = function (fieldName) {
    var list = useMappedState(useCallback(function (state) {
        return fieldName ? state.fieldsOptions[fieldName] : [];
    }, [fieldName]));
    var dispatch = useDispatch();
    var setList = useCallback(function (optionList) {
        return dispatch({ type: ActionEnum.SET_FIELD_OPTIONS, optionsList: optionList });
    }, [dispatch]);
    return { options: list, setOptions: setList };
};
//# sourceMappingURL=options.hook.js.map